import { push } from 'redux-first-history';
import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import Api from '../../../../helpers/api';
import { sendRequest } from '../../../../helpers/saga';
import { logger } from '../../../../helpers/logger';
import notifications from '../../../../redux/notifications/actions';
import { keyByProperty } from '../../../../helpers/core';
import { t } from '../../../../i18n';

const api = new Api('partners/:id');
const partnersListApi = new Api('partners');

function* loadData(data) {
  try {
    const { id, isEdit } = data.payload;
    const result = yield call(sendRequest, api.load, { id }, notifications.REQUEST_ERROR);

    if (result) {
      const { data: dataResult } = result;

      yield put(actions.loadDataSuccess({ data: { ...dataResult, id } }));

      if (isEdit) {
        yield put(actions.edit({ id, partner: { ...dataResult } }));
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* updateUser(data) {
  try {
    const { payload } = data;
    const { editForm, id } = payload;

    const propsArray = Object.values(editForm);
    const partner = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(
      sendRequest,
      api.updateItem,
      {
        data: { partner },
        id,
      },
      notifications.REQUEST_ERROR,
    );

    if (result && result.data) {
      yield put(actions.saveSuccess({ data: partner }));
      yield loadData({ payload: { id } });
      yield put(push(`/partners/${id}`));
      yield put(
        notifications.addNotification({
          headline: t('dash.common.notification.success_headline'),
          type: 'success',
          message: t('dash.common.notification.updated_successfully', { item: t('dash.admin.partners.partner_title') }),
        }),
      );
    } else {
      yield put(actions.saveError({ data: result }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* addUser(data) {
  try {
    const { payload } = data;
    const { editForm } = payload;

    const propsArray = Object.values(editForm);
    const partner = keyByProperty(propsArray, 'name', prop => prop.value);

    const result = yield call(
      sendRequest,
      partnersListApi.createItem,
      {
        data: { partner },
      },
      notifications.REQUEST_ERROR,
    );

    if (result) {
      if (result.data) {
        const { id } = result.data;
        yield put(actions.saveSuccess({ data: { ...partner, id } }));
        yield loadData({ payload: { id } });

        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.success_headline'),
            type: 'success',
            message: t('dash.common.notification.added_successfully', { item: t('dash.admin.partners.partner_title') }),
          }),
        );

        yield put(push(`/partners/${id}`));
      } else {
        yield put(actions.saveError());

        yield put(
          notifications.addNotification({
            headline: t('dash.common.notification.error_headline'),
            type: 'error',
            message: t('dash.common.notification.something_went_wrong'),
          }),
        );
      }
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadFormData() {
  try {
    const result = yield call(sendRequest, api.loadFormData, {}, notifications.REQUEST_ERROR);

    if (result) {
      const { data } = result;

      yield put(actions.loadFormData({ data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

function* loadFormDataOnAdd() {
  try {
    const result = yield call(sendRequest, partnersListApi.loadFormData, {}, notifications.REQUEST_ERROR);

    if (result) {
      const { data } = result;

      yield put(actions.loadFormData({ data }));
    }
  } catch (error) {
    logger.error(error);
  }
}

export { loadData, updateUser, addUser, loadFormData, loadFormDataOnAdd };
export default function* rootSaga() {
  yield all([
    takeEvery(actions.LOAD, loadData),
    takeEvery(actions.SAVE, updateUser),
    takeEvery(actions.ADD, addUser),
    takeEvery(actions.EDIT, loadFormData),
    takeEvery(actions.CREATE, loadFormDataOnAdd),
  ]);
}
